import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.scss'
import './assets/css/main.scss'
import { create, NMessageProvider } from 'naive-ui'
const naive = create({
  components: [ NMessageProvider ]
})
createApp(App).use(store).use(naive).use(router).mount('#app')
